<template>
  <v-dialog v-model="show" max-width="400">
    <v-card>
      <v-card-title class="body-1">
        {{ $vuetify.lang.t('$vuetify.SESSION') }}
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-col cols="12" class="d-flex justify-end pa-0">
          <v-btn
            text
            class="my-2"
            small
            color="accent"
            @click="setEndTimeAsNow()"
            >Set as now</v-btn
          >
        </v-col>
        <v-datetime-picker
          v-model="endTime"
          :label="$vuetify.lang.t('$vuetify.END_TIME')"
          date-format="dd-MM-yyyy"
          :text-field-props="{ outlined: true }"
        >
          <template v-slot:dateIcon>
            <v-icon>mdi-calendar-outline</v-icon>
          </template>
          <template v-slot:timeIcon>
            <v-icon>mdi-clock-outline</v-icon>
          </template>
        </v-datetime-picker>
        <v-text-field
          v-model="costInCents"
          :label="$vuetify.lang.t('$vuetify.COST_IN_CENTS')"
          hide-details
          outlined
          :disabled="
            session.ComputeCostAutomatically || computeCostAutomatically
          "
        ></v-text-field>
        <v-checkbox
          v-model="computeCostAutomatically"
          label="Automatic cost"
        ></v-checkbox>
        <v-checkbox
          v-model="chargeForSession"
          label="Make payment"
        ></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveSessionInfo()">
          {{ $vuetify.lang.t('$vuetify.SAVE') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'EditSessionDialog',
  props: {
    session: {
      type: Object,
      required: true
    },
    visible: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {
      endTimePicker: false,
      endTime: '',
      computeCostAutomatically: false,
      chargeForSession: false,
      costInCents: 0
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    }
  },
  created() {
    const currentDate = new Date(this.session.EndTime)
    this.endTime = currentDate
  },
  methods: {
    datePickerFormat(dateValue) {
      const date = new Date(dateValue)
      return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
    },
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    saveSessionInfo() {
      this.$store.dispatch('sessions/modifySession', {
        ParkingSessionId: this.session.Id,
        EndTime: this.endTime,
        CostInCents: this.costInCents,
        ComputeCostAutomatically: this.computeCostAutomatically,
        ChargeForSession: this.chargeForSession
      })
    },
    setEndTimeAsNow() {
      this.endTime = new Date()
    }
  }
  //   created() {
  //     this.$store
  //       .dispatch('sessions/getSessionInvoices', this.sessionId)
  //       .then(invoices => {
  //         this.invoices = invoices
  //       })
  //   }
}
</script>
